<template>
  <div class="field" :class="question.errorMessage ? 'errorBorder' : ''">
    <div class="text title_text">
      <span>{{ question.num }}、</span>{{ question.title }}
      <span v-if="question.must === 1" class="req">*</span>
    </div>
    <div class="ui-controlgroup">
      <div class="ui-radio" v-for="(item,index) in question.options" :key="index"
           @click="selectCurrent( question.num, index, question)">
        <span class="jqradiowrapper">
          <a class="jqradio" :class=" selected[index] ? 'jqchecked' : '' " href="javascript:;"></a>
        </span>
        <div class="label">{{ item }}</div>
      </div>
    </div>
    <div class="errorMessage">{{ question.errorMessage }}</div>
  </div>
</template>
<script>

export default {
  props: {
    question: Object
  },
  data() {
    return {
      selected: [false, false, false, false, false, false, false, false, false, false, false, false, false]
    }
  },
  created() {
    const question = this.question;
    if (question.answer !== undefined && question.answer !== null && typeof question.answer === "number") {
      this.$set(this.selected, question.answer - 1, true);
    }
  },
  methods: {
    selectCurrent(num, i, question) {
      let self = this
      self.selected.map(function (item, index) {
        if (index === i) {
          self.$set(self.selected, index, true)
        } else {
          self.$set(self.selected, index, false)
        }
      })
      question.finish = 1;
      question.answer = (i + 1);
      question.errorMessage = ''
      self.$emit('listenToChildEvent', num, i + 1, question)
    }
  }
}
</script>
<style lang="stylus" scoped>
.ui-controlgroup, .ui-radio {
  background: none repeat scroll 0 0 #fff;
  border-bottom: 1px solid #d5d5d5;
  border-right: 1px solid #d5d5d5;
  /*font-size: 16px;*/
  min-height: 43px;
  position: relative;
  overflow: hidden;
}

.jqradiowrapper {
  display: block;
  float: left;
  margin: 11px 4px 10px 11px;
}

.jqradio {
  background-color: #fafafa;
  border: 1px solid #cacece;
  padding: 9px;
  border-radius: 50px;
  display: inline-block;
  position: relative;
}

a.jqchecked {
  background-color: #53a4f4;
  color: #99a1a7;
  border: 1px solid #53a4f4;
  -webkit-appearance: none;
}

a.jqchecked:after {
  content: ' ';
  width: 10px;
  height: 10px;
  border-radius: 50px;
  position: absolute;
  top: 4px;
  background: #fff;
  text-shadow: 0px;
  left: 4px;
  font-size: 32px;
}

.label {
  display: block;
  margin-left: 40px;
  padding: 12px 10px 10px 0;
  cursor: pointer;
}

.req {
  color: red
}

.title_text {
  font-weight: bold;
}
</style>
